/**
* This file is loaded asyncronously in the footer.
* All custom global scripts should be included here.
*/
(function(){
	'use strict';

	// rerun lazyload on screen size updates
	window.addEventListener( 'resize', function() { dbs.lazyload(); } );

	// Load event function ... most custom stuff goes here. Safer for async.
	window.addEventListener( 'load', function() {
		var search_form = jQuery( '#search-form' );
		var search_input = jQuery( '#search-input' );
		search_form.click( function( e ) {
			if( jQuery( event.target ).hasClass( 'search-form__button' ) && search_input.val() == "" ) {
				search_input.focus();
				search.toggleClass( 'search-form--active' );
				event.preventDefault();
			} else {
				search_input.focus();
				search_form.addClass( 'search-form--active' );
			}
		});

		// adds class to nav menu to adjust break points to fit extra menu items
		jQuery('.search-form svg').on('click', function(event){
				// width determines the width of the search field when expanded
				var windowSize = jQuery(window).width();
				if ( windowSize >= 992) {
					console.log("hello");
					event.preventDefault();
					jQuery('.search-form').css('width', '10rem');
					jQuery('.search-form__field').addClass('search-form__focus');
				}
			});

		search_input.focusout( function( event ) {
			if( search_input.val() == "") {
				searchForm.removeClass( 'search-form--active' );
			}
		});

		// search child dom elements for a[href], and follow the fist one on click events 2015-11-03
		jQuery( ".linkclicker" ).click( function(e) {
			var _this = jQuery( this );
			if ( _this.find( "a" ) ) {
				e.preventDefault();
				if ( _this.find( "a:first" ).attr( "target" ) ) {
					// new tab
					window.open( _this.find( "a:first" ).attr( "href" ) );
				} else {
					// same tab
					window.location = _this.find( "a:first" ).attr( "href" );
				}
			}
		});

		// 2016-05-15, force opening external links, and pdf's, in new tab.
		if ( ! jQuery( 'a' ).attr( 'target' ) ) {
			jQuery( 'a[href^=http]:not([href*="' + dbs.http_host + '"])' ).attr( 'target', '_blank' ).attr( 'rel', 'noopener' );
			jQuery( 'a[href$=".pdf"]' ).attr( 'target', '_blank' );
		}

        // Accessible functionality to dismiss dbs text in the footer.
        jQuery('#dbs-chev')
        .on('focus', function(event) {
            $(this).addClass('expand-content');
            })
        .on('keyup', function(event){
            if (event.keyCode == 27) { // escape key maps to keycode `27`
                $(this).removeClass('expand-content');
            }
        })
        .on('blur', function(event) {
            $(this).removeClass('expand-content');
        });
		// 2017-09-12, add a X "clear form field" option to these fields:

		// This is causing problems, and from what I can tell, not being used anyway.
		//jQuery( "input[type=text],input[type=email],textarea" ).( { color: "#999" } );

		/**
		 * 	The following removes gratuitous p tags inserted by the editor around img tags. 2018-03-28
	 	 */
		jQuery( ".layout p" ).each( function() { 	         		// For each paragraph of .layout class
			if ( (jQuery(this).find( "img" ).length ) &&     		// If there's an image
					( !jQuery.trim(jQuery(this).text()).length ) ) {// and there's no text, then ... get mean.
				jQuery(this).closest( "p" ).find( "*" ).first().addClass( "unwrapped" ).unwrap();  // if the ancestor is a p tag, do what you have to do
			}
		});

		/**
		* Force external links to open in a new tab.
		* 2019-07-11 - TA
		*/
		// From https://stackoverflow.com/questions/2910946/test-if-links-are-external-with-jquery-javascript
		function link_is_external(link_element) {
			return (link_element.host !== window.location.host);
		}

        var anchorElements = document.getElementsByTagName('a');
    		for (let anchorElement of anchorElements) {

    			if (link_is_external(anchorElement)) {
    				anchorElement.classList.add('external-link');
    				anchorElement.setAttribute('target','_blank');
    				anchorElement.setAttribute('rel','noopener');

    				// Add assistive text to alert of external links
    				var assistiveText = '<span class="assistive">. External Link. Opens in new window.</span>';
    				var assistiveTextContainer = document.createElement('span');
    				assistiveTextContainer.innerHTML = assistiveText;
    				anchorElement.appendChild(assistiveTextContainer.firstChild);
    			}
    		}  // END FORCE EXTERNAL LINKS


    		jQuery('.flickity-prev-next-button').wrapAll('<div class="flickity-button-container"></div>');
    		jQuery('.flickity-button-container').insertAfter('#go-to-slider-controls');

		// A total of six blocks should appear in the partial section. The goal of this functionality is to remove the block that pertains to the page a user is currently viewing.
		// Beyond this, the goal is to remove any pages above six, which will ensure that the partial never includes additional blocks or rows of content.
		var blocksCounter = 0;
		var removed = '';

		jQuery('.flex-block__cell').each(function(){
			var pageId = $(this).data('myval'); // Get each flex-block__cell's data attribute (set to the relavant page id of the page the content block links to)

			if (jQuery('body').hasClass(pageId)) {
				$(this).remove(); // Remove the content block that pertains to the page currently being viewed.
			} else {
				blocksCounter ++;
			}
			if (blocksCounter > 6) { // Removes unneeded blocks to keep grid at 6. nextAll() needs the 'div' selector to keep it from grabbing too many elements.
				jQuery('.flex-block__cell:nth-child(6)').nextAll('div').remove();
			}
		});


		/**
		 * Captures Google Analytics Client ID and inputs into hidden form field
		 */
		function fillClientId() {
			// no ga on local or staging
			if ( typeof ga === "undefined" ) return;
			// Capture Client ID
			var clientId = ga.getAll()[0].get('clientId');
			// Populate hidden form field with Client ID
			jQuery('.g-id input').val(clientId);
		}

		// On pages with client ID form field, populate
		if (jQuery('.g-id input').length) {
			// Give GTM time to load
			setTimeout(function() {
				fillClientId();
			}, 2000);
		}

	}); // end load event
})();
